import { useContext } from "react";
import dynamic from 'next/dynamic';
// import LayoutComponent from "../../components/layout";
// import HeadComponent from "../../components/layout/Head";
import Image from 'next/image'
import AppContext from "../../store/AppContext";
import Link from "next/link";
// import Head from 'next/head';
import { loadServerSideProps } from "../../utils/utils";
const DynamicLayoutComponent = dynamic(() => import('../../components/layout'));
const DynamicHeadComponent = dynamic(() => import('../../components/layout/Head'));

export const getStaticProps = (async (context:any) => {
    return { props: await loadServerSideProps(context?.req?.url)}
})

const Contact = ({seo}:any) => {
    const { branchs } = useContext(AppContext);

    const ItemBranch = ({ item }: any) => {
        return <div className="flex flex-col gap-[4px] justify-center items-center">
            <h3 className="text-xl">{item.name}</h3>
            <p className="text-sm">{item.address}</p>
            <div className="flex flex-row items-center">
                {
                    item.phone?.map((p: any, index: number) => {
                        if (index === item.phone?.length - 1) {
                            return <div key={index} className="flex flex-row items-center gap-1">
                                <p className="underline text-sm">{p}</p>
                            </div>
                        }
                        return <div key={index} className="flex flex-row items-center gap-1">
                            <p className="text-sm underline ">{p}</p>
                            <span className="mr-1">-</span>
                        </div>
                    })
                }
            </div>
            <p className="text-sm ">{ }</p>
            {/* <p className="text-sm">Email: {item.email}</p> */}
            <p className="inline text-sm">Facebook: <Link prefetch={false} className="underline inline text-[#13C2C2] text-sm " href={item.facebook}>Bấm để chat</Link></p>
        </div>
    }
    return (<>
        <DynamicHeadComponent seo={seo}/>
        <DynamicLayoutComponent className='' isLoading={false}>
            <div className="flex w-full pt-[88px] pb-[152px] relative items-center justify-center">
                <Image
                    className="w-full"
                    alt={"contact_background"}
                    src={"/asset/image/contact_bg.webp"}
                    quality={100}
                    fill
                    sizes="100vw"
                    style={{
                        objectFit: 'cover',
                    }}
                />
                <div id="contact_main" className="bg-[#F5F5F5] w-[70%] h-full z-[1] rounded-[12px] p-[24px] flex flex-col">
                    <div className="flex flex-col relative h-[178px] py-[30px] items-center justify-center mb-[24px]">
                        <Image
                            className="w-full"
                            alt={"contact_top"}
                            src={"/asset/image/contact_top.webp"}
                            quality={100}
                            fill
                        />
                        <div className="flex flex-row gap-[24px] w-full justify-center items-center">
                            <div className="z-[16] min-w-[197px] h-[130px] bg-[#FFFFFFE5] flex flex-col gap-[4px] p-[10px] relative rounded-[8px]">
                                <Image
                                    className="relative w-[62px] h-[62px]"
                                    alt={"techcombank"}
                                    src={"/asset/image/techcombank.svg"}
                                    width={62}
                                    height={62}
                                />
                                <p className="inline text-sm">Số tài khoản: Đang cập nhật...</p>
                                <p className="inline text-sm">Chủ tk: Đang cập nhật...</p>
                            </div>
                            <div className="z-[16] min-w-[197px] h-[130px] bg-[#FFFFFFE5] flex flex-col gap-[4px] p-[10px] relative rounded-[8px]">
                                <Image
                                    className="relative w-[62px] h-[62px]"
                                    alt={"contact_top"}
                                    src={"/asset/image/vietcombank.svg"}
                                    width={62}
                                    height={62}
                                />
                                <p className="inline text-sm">Số tài khoản: Đang cập nhật...</p>
                                <p className="inline text-sm">Chủ tk: Đang cập nhật...</p>
                            </div>
                            <div className="z-[16] min-w-[197px] h-[130px] bg-[#FFFFFFE5] flex flex-col gap-[4px] p-[10px] relative rounded-[8px]">
                                <Image
                                    className="relative w-[62px] h-[62px]"
                                    alt={"contact_top"}
                                    src={"/asset/image/momo.svg"}
                                    width={62}
                                    height={62}
                                />
                                <p className="inline text-sm">Số tài khoản: Đang cập nhật...</p>
                                <p className="inline text-sm">Chủ tk: Đang cập nhật...</p>
                            </div>
                        </div>
                    </div>
                    <div className="w-full flex flex-row gap-[24px] flex-1 ">
                        <div id="contact_left" className="w-1/2 h-full flex flex-col bg-[#ffffff] rounded-[8px] p-[24px]">
                            {
                                branchs?.map((item: any, index: any) => {
                                    if (index === branchs?.length - 1) {
                                        return <div key={item.id} className="flex flex-col gap-[16px] mb-[16px]">
                                            <ItemBranch item={item} />
                                        </div>
                                    }
                                    return <div key={item.id} className="flex flex-col gap-[16px] mb-[16px]">
                                        <ItemBranch item={item} />
                                        <div className="h-[1px] bg-[#D9D9D9] w-full"></div>
                                    </div>
                                })
                            }
                        </div>
                        <div className="w-1/2 h-full relative">

                        </div>
                    </div>
                </div>
            </div>
        </DynamicLayoutComponent>
    </>);
}

export default Contact;